import { render, staticRenderFns } from "./TransferTab4.vue?vue&type=template&id=4cdc6b12&scoped=true"
import script from "./TransferTab4.vue?vue&type=script&lang=js"
export * from "./TransferTab4.vue?vue&type=script&lang=js"
import style0 from "./TransferTab4.vue?vue&type=style&index=0&id=4cdc6b12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdc6b12",
  null
  
)

export default component.exports